module.exports = __webpack_public_path__ + "img/w75b.c4a4d1ca.jpg";